import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import { RadioButton, RadioGroup } from 'src/components/atoms/input/RadioButton'
import { StoreProps } from 'src/stores'

interface State {
  valid: boolean
  noRedirect: boolean
}

@inject('wizardStore')
@observer
export class ProgressInput extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.provision.progress,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionProgress' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionProgress' })
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    wizardStore.provision.progress = key
    this.setState({ valid: true })
  }

  renderRadio = (label, name, value) => {
    const { wizardStore } = this.props
    return (
      <RadioButton
        label={label}
        name={name}
        value={value}
        defaultChecked={wizardStore.provision.progress === value}
        onClick={() => this.handleAnswerClick(value)}
      />
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    const radio1 = 'Ich weiß, was ich will, habe aber noch nicht vorgesorgt.'
    const radio2 =
      'Ich habe schon eine Sterbegeld\u00ADversicherung abgeschlossen.'
    const radio3 = 'Ich stehe noch ganz am Anfang der Vorsorge.'
    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={55} end={65} />
          </ProgressBarContainerWizard>
          <Question>Wo stehen Sie mit Ihrer Vorsorge&shy;planung?</Question>
          <FormContainer>
            <RadioGroup>
              {this.renderRadio(radio1, 'progress', 'PREPARED')}
              {this.renderRadio(radio2, 'progress', 'INSURANCE_SET')}
              {this.renderRadio(radio3, 'progress', 'STARTING')}
            </RadioGroup>
          </FormContainer>
        </Box>
        <Navigation
          next='/planung/vorsorge/zeitplan/'
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(ProgressInput)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/provision/ProgressInput.tsx